<template>
<v-dialog v-model="dialog" scrollable persistent max-width="700px" :fullscreen="$vuetify.breakpoint.smAndDown" transition="dialog-transition">
    <v-card>
        <v-card-title primary-title>
            <div class="pa-2 hotel-modal-header">
                {{item.name}}
            </div>
            <v-spacer></v-spacer>
            <v-icon @click="emitExit()">close</v-icon>
        </v-card-title>

        <v-card-text class="">
            <div class="" v-html="description">
            </div>
            <v-card-actions v-if="item.slug == 'booking-engine'">
                <v-btn v-if="!item.connected" color="primary" @click="activate()">Activeaza</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="item.connected" color="primary" @click="goTo()">Acceseaza Link</v-btn>
            </v-card-actions>
            <div class="pa-2 regular">
                {{ $t('distribution.selection_rate_plan')}}
            </div>
            <div v-for="(rate, index) in rate_plans" :key="rate.id">
                <v-row>
                    <v-col md="6" cols="12" class="py-0">
                        <v-checkbox class="ma-0 pa-0" :disabled="!item.connected" :label="rate.name" v-model="rate.pos" :value="item.pos_slug" @change="isDirty(rate.id)"></v-checkbox>
                    </v-col>
                </v-row>
            </div>
        </v-card-text>
        <v-card-actions class="hotel-modal-footer">
            <v-btn color="primary" @click="emitExit()">{{ $t('button.cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading" @click="save()">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';
export default {

    props: {
        dialog: Boolean,
        item: Object,
        slug: String,
        pos_slug: String,
        hotel_id: [Number, String],
        hotel: Object
    },
    components: {

    },

    data() {
        return {
            loading: false,
            description: "",
            rate_plans: [],
            to_be_saved: [],
        }
    },

    watch: {
        dialog: function (newdialog, olddialog) {
            if(newdialog) {
                this.getDescription();
                this.getRatePlans();
            }
        }
    },

    created() {},

    methods: {
        ...mapActions('alert', ['success', 'error']),

        getDescription() {
            if(!this.item.slug) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/translations/pages?app_slug=juvo-console&fields[]=slug&search=distribution." + this.item.slug;


            this.$axios.get(endpoint)
                .then(response => {
                    this.description = response.data.data[0].translations.body.ro;
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {});
        },

        getRatePlans() {
            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/rate-plans";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel_id,
                    stamp: stamp,
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    let items = [];
                    response.data.data.forEach(function (rate) {
                        if(!rate.pos) {
                            rate.pos = [];
                        }
                        items.push(rate)
                    }.bind(this))
                    this.rate_plans = items;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});
        },

        isDirty(value) {
            if(this.to_be_saved.includes(value)) {
                this.to_be_saved = this.to_be_saved.filter(item => item !== value);
            } else {
                this.to_be_saved.push(value)
            }
        },

        async save() {
            this.loading = true;
            let promises = []
            if(this.to_be_saved.length) {
                promises = await this.to_be_saved.map(async function (item) {
                    let rate_plan = this.rate_plans.find(rate => rate.id == item)
                    await this.saveItem(rate_plan);
                }.bind(this))

            }
            Promise.all(promises)
                .then(() => {
                    this.to_be_saved = [];
                    this.loading = false;
                    this.emitExit();
                })
                .catch(error => {
                    console.log(error);
                    this.loading = false;
                    this.error('Oops, something went wrong!');
                })

        },

        saveItem(rate_plan) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/rate-plans/';

            return this.$axios.put(endpoint + rate_plan.id, rate_plan)
                .then(response => {
                    return new Promise(function (resolve, reject) {
                        resolve(response);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {});
        },

        goTo() {
            let env = '';
            if(process.env.VUE_APP_APP_ENV == 'local' || process.env.VUE_APP_APP_ENV == 'dev') {
                env = '.dev'
            }
            if(process.env.VUE_APP_APP_ENV == 'staging') {
                env = '.staging'
            }
            let url = 'https://' + this.$route.params.hotel_slug + env + '.mementobookings.com'
            window.open(url, '_blank');
        },

        activate() {
            let item = this.hotel;
            if(Array.isArray(item.meta)) {
                item.meta.push("mementobookings")
            } else {
                item.meta = ["mementobookings"];
            }
            item.static.images = [];
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";

            this.$axios.put(endpoint + item.id, item)
                .then(response => {
                    this.success('Booking engine a fost activat')
                    this.$emit('update');
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    this.loading_save = false;
                });
        },

        emitExit() {
            this.$emit('exit')
        }
    },
}
</script>
